const Icon = (props: any) => {
    return (
        <svg width={14} height={17} viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M9.4 7a2.4 2.4 0 11-4.8 0 2.4 2.4 0 014.8 0v0z"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13 7c0 5.714-6 9-6 9s-6-3.286-6-9a6 6 0 1112 0v0z"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Icon;
